import { Text, View } from "react-native";

import type { PublicBuylistRule } from "@/hooks/usePublicBuylist";
import { gameLabel } from "@/lib/catalog/games";

const rarityLabel = (value: string) =>
  value.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (letter) => letter.toUpperCase());

export function PublicBuylistRules({ rules }: { rules: PublicBuylistRule[]; }) {
  if (!rules.length) return null;
  return (
    <View className="gap-3">
      <Text accessibilityRole="header" className="font-title text-xl text-foreground">
        Buying by set and rarity
      </Text>
      {rules.map((rule, index) => (
        <View
          key={`${rule.game}:${rule.sets.join(",")}:${index}`}
          className="gap-1 rounded-xl border border-border bg-surface p-4"
        >
          <Text className="font-label text-sm text-foreground">
            {gameLabel(rule.game)} · {rule.sets.join(", ")} ·{" "}
            {rule.rarities.map(rarityLabel).join(", ")}
          </Text>
          <Text className="font-body text-sm text-muted-foreground">
            NM market ≥ ${Number(rule.min_market).toFixed(2)} ·{" "}
            {Number((Number(rule.cash_pct) * 100).toFixed(1))}% cash ·{" "}
            {Number((Number(rule.trade_pct) * 100).toFixed(1))}% trade of Near Mint market
          </Text>
        </View>
      ))}
    </View>
  );
}
